var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonPixel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 0,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 0,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 0,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 0,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 0,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 3,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 1,
    height: 1,
    fill: "#f8d838"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 1,
    height: 1,
    fill: "#f8d838"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 1,
    height: 1,
    fill: "#e52521"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 1,
    height: 1,
    fill: "#fcbc8c"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 1,
    height: 1,
    fill: "#2b4bd8"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 1,
    height: 1,
    fill: "#3a1f0b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPixel);
export default __webpack_public_path__ + "static/media/person-pixel.485b83e300e1c71092b6947147821b06.svg";
export { ForwardRef as ReactComponent };